import React, { createContext, useContext } from 'react'
import { useTheme, ThemeMode, EffectiveTheme } from '../hooks/useTheme'

interface ThemeContextType {
  mode: ThemeMode
  effectiveTheme: EffectiveTheme
  isLateNight: boolean
  setMode: (mode: ThemeMode) => void
  toggleTheme: () => void
  isDark: boolean
  // Legacy alias — existing call sites read `theme`
  theme: EffectiveTheme
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined)

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const value = useTheme()

  return (
    <ThemeContext.Provider
      value={{
        ...value,
        theme: value.effectiveTheme,
      }}
    >
      {children}
    </ThemeContext.Provider>
  )
}

export const useThemeContext = (): ThemeContextType => {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error('useThemeContext must be used within a ThemeProvider')
  }
  return context
}
